
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slugParent]/[[...slugChild]]",
      function () {
        return require("private-next-pages/[slugParent]/[[...slugChild]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slugParent]/[[...slugChild]]"])
      });
    }
  